import dynamic from "next/dynamic";
import Variables from "../../../variables/variables.json";
import Section from "../../../components/Section";
import SectionLayout from "../_sectionLayout";

export default function Kontakt(props) {
	const { miasto, podatek } = props;

	const cityUrlName = Variables.miasta[miasto]?.name?.url;

	if (!cityUrlName) {
		return <div>Brak danych dla miasta: {miasto}</div>;
	}

	const CityKontaktPL = dynamic(() =>
		import(`../../../content/witryna/kontakt/${cityUrlName}/kontakt_pl.mdx`),
	);

	return (
		<SectionLayout miasto={miasto} podatek={podatek}>
			<Section center mdx>
				<CityKontaktPL />
			</Section>
		</SectionLayout>
	);
}
